import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Button, Spinner } from "@material-tailwind/react";

import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { ToastContainer, toast } from "react-toastify";

import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";

import BanquesForm from "./Banques_form";
import { getAllBanquesApi, deleteBanqueApi } from "api/banques";

function BanquesTable({ accessList }) {
  const [banqueFormAction, setBanqueFormAction] = useState("show");
  const [showBanqueForm, setBanqueForm] = useState(false);
  const [banquesList, setBanquesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBanque, setSelectedBanque] = useState([]);
  const [filterFormData, setFilterFormData] = useState({
    label: "",
  });

  const [filteredBanquesList, setFilteredBanquesList] = useState([]);

  useEffect(() => {
    getTableData(filterFormData.label);
  }, []);

  const getTableData = async (label) => {
    try {
      setIsLoading(true);
      const response = await getAllBanquesApi(label);

      if(!response)
        return setBanquesList([]);

      setBanquesList(response);
      setFilteredBanquesList(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteBanque = (id) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer cette banque ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await deleteBanqueApi(id);
            getTableData(filterFormData.label);
            Swal.fire("Supprimée", "", "success");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleBanqueModal = (action, data) => {
    try {
      setBanqueForm(!showBanqueForm);
      setBanqueFormAction(action);
      setSelectedBanque(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowToast = (type, message) => {
    if (type === "success") {
      setBanqueForm(!showBanqueForm);
      getTableData(filterFormData.label);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleFilterChange = (value) => {
    setFilterFormData({ label: value });
    
    // Apply filter
    let filtered = banquesList;
    
    if (value) {
      filtered = filtered.filter(item => 
        item.label && item.label.toLowerCase().includes(value.toLowerCase())
      );
    }
    
    setFilteredBanquesList(filtered);
  };

  const clearFilters = () => {
    setFilterFormData({ label: "" });
    setFilteredBanquesList(banquesList);
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />
      <Dialog size="xl" open={showBanqueForm} handler={handleBanqueModal}>
        <DialogHeader>
          <p className="w-full text-center">
            {banqueFormAction === "add"
              ? "Nouvelle banque"
              : banqueFormAction === "edite"
              ? "Modifier la banque"
              : "Voir les détails de la banque"}
          </p>
        </DialogHeader>
        <DialogBody>
          <BanquesForm
            closePopup={handleBanqueModal}
            banqueFormAction={banqueFormAction}
            showToast={handleShowToast}
            selectedBanque={selectedBanque}
          />
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0">
          Gestion des Banques
        </div>
        {accessList.Add && (
          <Button
            onClick={() => handleBanqueModal("add", null)}
            className="linear mb-5 rounded-[10px] bg-gray-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Nouvelle banque
          </Button>
        )}
      </header>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2"></div>

      {/* Filter Section */}
      <div className="mt-8 mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="flex flex-col md:flex-row gap-4 items-center">
            {/* Name Filter */}
            <div className="flex flex-col min-w-[200px]">
              <label className="text-sm font-medium text-gray-700 mb-1">Nom de la banque</label>
              <input
                type="text"
                placeholder="Rechercher par nom..."
                value={filterFormData.label}
                onChange={(e) => handleFilterChange(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
              />
            </div>
          </div>

          {/* Clear Filters Button */}
          <button
            onClick={clearFilters}
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors duration-200 font-medium"
          >
            Effacer les filtres
          </button>
        </div>

        {/* Results Count */}
        <div className="mt-4 text-sm text-gray-600 flex items-center justify-between">
          <span>
            {filteredBanquesList.length} résultat(s) sur {banquesList.length} banque(s)
            {filterFormData.label && (
              <span className="ml-2 text-blue-600 font-medium">
                (Filtres actifs)
              </span>
            )}
          </span>
          {filterFormData.label && (
            <span className="text-xs text-gray-500">
              Appuyez sur "Effacer les filtres" pour voir tous les résultats
            </span>
          )}
        </div>
      </div>

      <div className="mt-8 overflow-x-scroll">
        {isLoading ? (
          <div className="flex w-full items-center justify-center">
            <Spinner className="h-12 w-12" />
          </div>
        ) : (
          <div
            className="mt-8 overflow-x-scroll"
            style={{ height: "50vh", overflowY: "scroll" }}
          >
            <table className="w-full">
              <thead>
                <tr>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Nom de la banque</p>
                  </th>

                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Valeur de la banque</p>
                  </th>

                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Actions</p>
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredBanquesList.map((el, index) => (
                  <tr key={el._id || index}>
                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <p className="text-sm font-bold text-navy-700 dark:text-white">
                        {el.label}
                      </p>
                    </td>

                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <p className="text-sm font-bold text-navy-700 dark:text-white">
                        {el.value}
                      </p>
                    </td>

                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <div className="flex">
                        {accessList.Read && (
                          <IoEyeSharp
                            size={20}
                            color="gray"
                            className="cursor-pointer"
                            onClick={() => handleBanqueModal("show", el)}
                          />
                        )}
                        {accessList.Update && (
                          <HiPencilAlt
                            size={20}
                            color="#236571"
                            className="ml-4 mr-4 cursor-pointer"
                            onClick={() => handleBanqueModal("edite", el)}
                          />
                        )}
                        {accessList.Delete && (
                          <FaTrash
                            size={20}
                            color="#cf503f"
                            className="cursor-pointer"
                            onClick={() => handleDeleteBanque(el._id)}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Card>
  );
}

export default BanquesTable;
